import { MainLayout } from 'views/layouts'
import { H2 } from 'views/components/UI/Text'
import {
  Container,
  Header,
  Body,
  NoDataContainer,
  NoDataSubContainer,
  TextContainer,
  NoDataText,
} from 'views/screens/Platform-administrator/Analytics/styled'

const AnalyticsMigrationNotice = () => {
  return (
    <MainLayout>
      <Container>
        <Header>
          <H2 marginBottom="40px">Analíticas</H2>
        </Header>
        <Body>
          <NoDataContainer style={{ width: '100%', height: 'auto', minHeight: '72px', marginTop: '24px' }}>
            <NoDataSubContainer style={{ justifyContent: 'center' }}>
              <TextContainer>
                <NoDataText style={{ textAlign: 'center' }}>
                  Esta funcionalidad fue migrada al módulo de procesos. Dirígete al proceso del cual
                  quieres ver la analítica.
                </NoDataText>
              </TextContainer>
            </NoDataSubContainer>
          </NoDataContainer>
        </Body>
      </Container>
    </MainLayout>
  )
}

export default AnalyticsMigrationNotice
